/**
 * Page scroll lock - the ONE place that may touch overflow on <html>/<body>.
 *
 * Why this exists (client, 2026-09-19, "Creed broken after coming back home"):
 * the menu and the page loader each wrote `document.body.style.overflow`
 * independently. Open the menu, pick Home, the film hero raises the loader
 * while the menu is still closing: the loader saved "hidden" as the value to
 * restore, the menu then cleared it, the loader hid and put "hidden" back.
 * <body> stayed `overflow: hidden` for the rest of the session.
 *
 * And because <html> is `overflow-x: clip`, body's overflow does NOT
 * propagate to the viewport - the page still scrolls, but <body> itself
 * becomes a scroll container, so every `position: sticky` inside it (the
 * Creed stage) stops sticking: photo scrolls away, black runway, no glide.
 *
 * Rules:
 *  - Callers hold a named lock; the page is locked while ANY lock is held.
 *  - The lock lives on <html> (the real scroller), never on <body>.
 *  - Nothing is saved/restored: the state is derived from the set every time,
 *    and any stray inline overflow on <body> is wiped on every update.
 */
const holders = new Set();

function apply() {
  const html = document.documentElement;
  const body = document.body;
  if (holders.size) html.style.overflow = "hidden";
  else html.style.removeProperty("overflow");
  if (body.style.overflow) body.style.removeProperty("overflow");
}

export function lockScroll(key) {
  holders.add(key);
  apply();
}

export function unlockScroll(key) {
  holders.delete(key);
  apply();
}

export function isScrollLocked() {
  return holders.size > 0;
}
